// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df7a783c","455":"3a3f2224","977":"b05446bb"}[chunkId] + ".chunk.js";
};